import React, { useState } from "react";
import { useHistory, useLocation } from "react-router";
import Swal from "sweetalert2";
import Button from "../../../components/Button/index";
import Select from "../../../components/Dropdown/index";
import InputField from "../../../components/InputField/index";
// import "./individual.css";
import Loader from "../../../components/Loader";
import {
  requestAmbassador,
  requestBooking,
} from "../../../services/apiservice";
import apiroutes from "../../../services/apiroutes";
import ModalComponent from "../../../components/Modal";
import { getAmbassadorAuth, getAuth } from "../../../services/auth";

const IndividualPartner = () => {
  const history = useHistory();
  const token = getAmbassadorAuth();
    const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const verificationId = urlParams.get("verificationId");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [nin, setNIN] = useState("");
  const [occupation, setOccupation] = useState("");
  const [officeAddress, setOfficeAddress] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
    const [loading, setLoading] = useState(false);
    const [visibleVerifyOtp, setVisibleVerifyOtp] = useState(false);
    const [verificationCode, setVerificationCode] = useState("");

  const checkEmail = () => {
    var filter =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if (!filter.test(email)) {
      Swal.fire({
        showConfirmButton: false,
        timer: 4000,
        text: `Please provide a valid email address`,
        icon: "error",
      });
      return false;
    } else {
      handleEnterprise();
    }
  };

  const handleEnterprise = () => {
    if (
      !(firstName,
      lastName,
      address,
      nin,
      occupation,
      email,
      phone,
      officeAddress)
    ) {
      Swal.fire({
        showConfirmButton: false,
        timer: 4000,
        text: "All fields are required.",
        icon: "error",
      });
    } else if (phone.length < 11 || phone.length > 11) {
      Swal.fire({
        showConfirmButton: false,
        timer: 4000,
        text: "Only Nigerian numbers are allowed. Please provide a Nigerian number.",
        icon: "error",
      });
    } else {
      setLoading(true);
      const accountUpgradeDetails = {
        firstName,
        lastName,
        phone,
        email,
        address,
        nin,
        occupation,
        officeAddress,
      };     
      // const ambassadorId = "7DAE9298-82DE-4350-AC84-20C4775B37B5"
      requestAmbassador(
        // apiroutes.ProcessAmbassadorUpgradeRequest(ambassadorId),
        apiroutes.ProcessAmbassadorUpgradeRequest(verificationId),
        "post",
        accountUpgradeDetails,
        null
      )
        .then((res) => {
          // console.log(res, "NUGAGEE")
          if (res.data.code === 1 || res.data.code === "1") {
            // alert(res.data.shortDescription)
            Swal.fire({
              showConfirmButton: false,
              timer: 5000,
              text: `Kindly complete OTP verification to complete your Upgrade request.`,
              icon: "success",
            });
            setLoading(false);
            setVisibleVerifyOtp(true)
            // setTimeout(() => {
            //   history.push("/");
            // }, 4000);
          } else {
            setLoading(false);
            Swal.fire({
              showConfirmButton: false,
              timer: 4000,
              text: `${res.data.shortDescription}`,
              icon: "error",
            });
            // setTimeout(() => {
            //   history.push("/");
            // }, 4000);
          }
        })
        .catch((err) => {
          setLoading(false);
          // setError(err.message);
          Swal.fire({
            showConfirmButton: false,
            timer: 4000,
            text: `${err?.response.data.shortDescription}`,
            icon: "error",
          });
        });
    }
  };
 
  const verifyCode = () => {
    setLoading(true);
    const verifyOtpDetails = {
      otp: verificationCode,
      phoneNumber: phone,
    };
    requestAmbassador(
      apiroutes.VerifyTier3AccountUpgradeRequestOtp(),
      "post",
      verifyOtpDetails,
      token
    )
      .then((res) => {
        // console.log(res, "NUGAGEE");
        if (res.data.code === 1 || res.data.code === "1") {
          // alert(res.data.shortDescription)
          Swal.fire({
            showConfirmButton: false,
            timer: 5000,
            text: `Your request is successful.`,
            icon: "success",
          });
          setLoading(false);
          setTimeout(() => {
            history.push("/");
          }, 4000);
        } else {
          setLoading(false);
          Swal.fire({
            showConfirmButton: false,
            timer: 4000,
            text: `${res.data.shortDescription}`,
            icon: "error",
          });
          // setTimeout(() => {
          //   history.push("/");
          // }, 4000);
        }
      })
      .catch((err) => {
        setLoading(false);
        // setError(err.message);
        Swal.fire({
          showConfirmButton: false,
          timer: 4000,
          text: `${err.message}`,
          icon: "error",
        });
      });
  };


  const toggleModalVerifyOtpClose = () => {
    setVisibleVerifyOtp(true);
  };

  //Verify OTP modal
  const width = 500;
  const height = 350;
  const modalTitle = "Enter Verification Code";
  const modalBodyVerifyOtp = (
    <div>
      <br />
      <br />
      <label htmlFor="email" className="label-auth">
        Enter your verification Code
      </label>
      <InputField
        type="text"
        placeholder="Verification code"
        onChangeMethod={(e) => setVerificationCode(e.target.value)}
      />
      <br />
      <br />
      {/* <p>
        Didn’t receive the code?{" "}
        <span
          style={{ cursor: "pointer", color: "rgba(86, 204, 242, 0.9)" }}
          onClick={() => {
            handlePhoneSendOtp();
          }}
        >
          Resend code
        </span>{" "}
        or{" "}
        <span
          style={{ cursor: "pointer", color: "rgba(86, 204, 242, 0.9)" }}
          onClick={() => setVisible(false)}
        >
          change number
        </span>
      </p> */}
      <Button
        text={loading ? <Loader dark={false} /> : "Verify"}
        handleButtonClick={verifyCode}
        disabled={!verificationCode}
        type="button"
      />
    </div>
  );

  return (
    <div>
         {/* alternative route popup */}
      <ModalComponent
        width={width}
        height={height}
        title={modalTitle}
        visible={visibleVerifyOtp}
        body={modalBodyVerifyOtp}
        handleClose={toggleModalVerifyOtpClose}
      />
      <section>
        <div className="contactform" style={{ marginTop: "140px" }}>
          <div className="contactformholder">
            <div className="partnerform">
              <h1>Tier 3 upgrade</h1>
              <p>Kindly provide the details below</p>

              <div>
                <label htmlFor="firstname">First Name</label>
                <InputField
                  type="text"
                  placeholder="Enter First Name"
                  onChangeMethod={(e) => setFirstName(e.target.value)}
                />
                <label htmlFor="lastname">Last Name</label>
                <InputField
                  type="text"
                  placeholder="Enter Last Name"
                  onChangeMethod={(e) => setLastName(e.target.value)}
                />
                <label htmlFor="phonenumber">NIN</label>
                <InputField
                  type="tel"
                  placeholder="XXXXXXXX"
                  onChangeMethod={(e) => setNIN(e.target.value)}
                />

                <label htmlFor="email">Email Address</label>
                <InputField
                  type="email"
                  placeholder="Example@gmail.com"
                  onChangeMethod={(e) => setEmail(e.target.value)}
                />
                <label htmlFor="phonenumber">Phone Number</label>
                <InputField
                  type="tel"
                  placeholder="080X XXX XXXX"
                  onChangeMethod={(e) => setPhone(e.target.value)}
                />
                <label htmlFor="Businessaddress">Address</label>
                <InputField
                  type="text"
                  placeholder="Enter Address"
                  onChangeMethod={(e) => setAddress(e.target.value)}
                />
                <label htmlFor="Businessaddress">Occupation</label>
                <InputField
                  type="text"
                  placeholder="Enter Occupation"
                  onChangeMethod={(e) => setOccupation(e.target.value)}
                />
                <label htmlFor="state">Office Address</label>
                <InputField
                  type="text"
                  placeholder="Enter Office Address"
                  onChangeMethod={(e) => setOfficeAddress(e.target.value)}
                />

                <Button
                  handleButtonClick={checkEmail}
                  text={
                    loading ? (
                      <div>
                        <Loader dark={false} />{" "}
                      </div>
                    ) : (
                      "Submit Details"
                    )
                  }
                  type="button"
                  btnstyle={{ backgroundColor: "#E21D00", margin: "20px 0px" }}
                  disabled={
                    !(
                      phone &&
                      email &&
                      firstName &&
                      lastName &&
                      address &&
                      nin &&
                      occupation &&
                      officeAddress
                    )
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IndividualPartner;
